import React, { useState } from 'react';
import '../styles/services.css';
import '../styles/about-mnh.css';
import { PhoneCall, House, Mail } from 'lucide-react';

import GeneralSurgery from '../components/GeneralSurgery';
import LaparoscopicSurgery from '../components/LaparoscopicSurgery';
import OncoSurgery from '../components/OncoSurgery';
import PlasticSurgery from '../components/PlasticSurgery';
import PediatricSurgery from '../components/PediatricSurgery';
import UroSurgery from '../components/UroSurgery';
import OrthopaedicSurgery from '../components/OrthopaedicSurgery';
import ObstetricsGayanocology from '../components/ObstetricsGayanocology';
import Chemotherapy from '../components/Chemotherapy';
import GeneralMedecine from '../components/GeneralMedecine';
import Cardiology from '../components/Cardiology';
import MedicalGasteroenterology from '../components/MedicalGasteroenterology';
import Radiology from '../components/Radiology';
import BiochemistryPathology from '../components/BiochemistryPathology';

function Services() {
  const serviceList = [
    'General Surgery',
    'Laparoscopic And GI Surgery',
    'Onco-Surgery',
    'Plastic & Reconstrucive Surgery',
    'Pediatric Surgery',
    'Uro - Surgery',
    'Orthopaedic Surgery',
    'Obstetrics & Gayanocology',
    'Chemotherapy',
    'General Medecine',
    'Cardiology',
    'Medical Gasteroenterology',
    'Radiology',
    'Biochemistry & Pathology'
  ];

  const [selectedService, setSelectedService] = useState(serviceList[0]);

  const renderServiceComponent = () => {
    switch (selectedService) {
      case 'General Surgery':
        return <GeneralSurgery />;
      case 'Laparoscopic And GI Surgery':
        return <LaparoscopicSurgery />;
      case 'Onco-Surgery':
        return <OncoSurgery />;
      case 'Plastic & Reconstrucive Surgery':
        return <PlasticSurgery />;
      case 'Pediatric Surgery':
        return <PediatricSurgery />;
      case 'Uro - Surgery':
        return <UroSurgery />;
      case 'Orthopaedic Surgery':
        return <OrthopaedicSurgery />;
      case 'Obstetrics & Gayanocology':
        return <ObstetricsGayanocology />;
      case 'Chemotherapy':
        return <Chemotherapy />;
      case 'General Medecine':
        return <GeneralMedecine />;
      case 'Cardiology':
        return <Cardiology />;
      case 'Medical Gasteroenterology':
        return <MedicalGasteroenterology />;
      case 'Radiology':
        return <Radiology />;
      case 'Biochemistry & Pathology':
        return <BiochemistryPathology />;
      default:
        return null;
    }
  };

  return (
    <>
    <div className="services-container">
      <img
        src={require("../assets/img/servicehead.png")}
        alt="Services Header"
        className="services-header-img"
      />
      
          <div className="gallery-overlay-title" style={{top:'70%'}}>
            Comprehensive Medical & Surgical services
            <p style={{fontWeight:'normal', fontSize:'35px',lineHeight:'1',color:'#FFFFFF', textAlign:'center'}}>
              From diagnostics to advanced treatments, all under one roof.</p>
          </div>
      
    </div>
    <div className="home-carousel-row">
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <PhoneCall size={48} color="#fff" />
            <span className="carousel-col-title">
              In Emergency give us a call<br />
              9434007688
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <House  size={48} color="#fff" />
            <span className="carousel-col-title">
              Get our Location<br />
              Dangalpara, Suri, Birbhum
            </span>
          </div>
        </div>
        <div className="home-carousel-col">
          <div className="carousel-col-content">
            <Mail size={48} color="#fff"/>
            <span className="carousel-col-title">
              Send an email<br />
              mdnhsuribir@gmail.com
            </span>
          </div>
        </div>
      </div>
      <section className="about-mnh-section">
        <div className="about-mnh-row">
          <div className="about-mnh-col about-mnh-col-3">
            <div className="about-mnh-col3-inner">
              <div className="about-mnh-col3-title">
                <h1>All Services</h1>
              </div>
              <div className="about-mnh-col3-btn-holder" style={{ flexDirection: 'column',padding:'15px' }}>
                {serviceList.map(service => (
                  <button
                    key={service}
                    className={`service-btn${selectedService === service ? ' active' : ''}`}
                    onClick={() => setSelectedService(service)}
                  >
                    {service}
                  </button>
                ))}
              </div>
            </div>
          </div>
          <div className="about-mnh-col about-mnh-col-9" style={{ flexDirection: 'column',padding:'15px' }}>
            {renderServiceComponent()}
          </div>
        </div>
      </section>
      <section className="about-mnh-section">
        <div className="about-mnh-row">
            <span style={{textAlign:'center'}}>
              Modern Diagnostics & Nursing Home Pvt. Ltd. Pvt. Ltd. Providing diagnostic, medical, and surgical services in Suri, Birbhum, with a focus on patient safety, ethical practice, and coordinated care.
            </span>
        </div>
      </section>
      <hr/>
    </>
  );
}

export default Services;
